import { useState, useEffect, useRef } from 'react';
import { tasksService } from '../services/api';

/**
 * Hook para polling de nuevas tareas (respaldo cuando WebSocket no funciona)
 * Consulta al servidor cada X segundos buscando tareas nuevas asignadas al usuario
 */
export const useTaskPolling = (currentUser, enabled = true) => {
  const [lastCheckTime, setLastCheckTime] = useState(null);
  const [newTaskDetected, setNewTaskDetected] = useState(null);
  const intervalRef = useRef(null);
  const lastTaskCountRef = useRef(0);

  // Extraer username para estabilizar dependencias
  const username = currentUser?.user?.username || currentUser?.username;
  
  useEffect(() => {
    if (!enabled || !username) {
      return;
    }
    
    const checkForNewTasks = async () => {
      try {
        // Obtener todas las tareas
        const tasks = await tasksService.getTasks();
        
        // Filtrar tareas asignadas al usuario actual
        const myTasks = tasks.filter(t => t.assignedTo === username);
        
        // Verificar si hay nuevas tareas desde la última verificación
        if (lastCheckTime) {
          const newTasks = myTasks.filter(task => {
            const taskDate = new Date(task.createdAt || task.fechaCreacion);
            return taskDate > lastCheckTime && task.estado === 'programada';
          });
          
          if (newTasks.length > 0) {
            setNewTaskDetected(newTasks[0]);
          }
        }
        
        setLastCheckTime(new Date());
        lastTaskCountRef.current = myTasks.length;
        
      } catch (error) {
        // Silenciar errores de timeout
        if (!error.message?.includes('timeout')) {
          console.error('Error en polling:', error.message);
        }
      }
    };

    // Primera verificación inmediata
    checkForNewTasks();

    // Polling cada 60 segundos (antes era 5 - causaba lentitud)
    intervalRef.current = setInterval(checkForNewTasks, 60000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [enabled, username, lastCheckTime]);

  const clearNewTask = () => {
    setNewTaskDetected(null);
  };

  return {
    newTaskDetected,
    clearNewTask
  };
};
